import { FC, useContext } from "react";

import { FormType, QuestionType } from "@simplyk/common";

import { useFrontendAuctionContext } from "../../../../../../common/contexts/FrontendAuctionContext";
import { FrontendFormContext } from "../../../../../../common/contexts/FrontendFormContext";
import { useFormV2Context } from "../../../contexts/FormV2Context";
import { CommunicationPreferencesFieldContainer } from "../CommunicationPreferences/CommunicationPreferencesFieldContainer";
import { QuestionField } from "../../questions/QuestionField/QuestionField";
import { SectionWrapper } from "../SectionWrapper";

import { useTranslate } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useIsGhostPreview } from "@/features/LiveFormEditor/LivePreview/useIsGhostPreview";

export const BuyerQuestionsSection: FC = () => {
  const { t } = useTranslate();
  const areQuestionsGhostPreview = useIsGhostPreview("TicketingV2BuyerQuestionsSection");
  const areCommunicationPreferencesGhostPreview = useIsGhostPreview("CommunicationPreferencesField");
  const { questions, type, isAuction, communicationPreferences, isMembership } = useFormV2Context();
  const { hasAlreadyBid } = useFrontendAuctionContext();
  const { displayExpressCheckout } = useContext(FrontendFormContext);

  if (isAuction && hasAlreadyBid) {
    return null;
  }

  const buyerQuestions = questions
    .filter((question) => !question.hasRate)
    .map((question, index) => ({ question, index }))
    .filter(({ question }) => displayExpressCheckout || question.type !== QuestionType.NotificationPhoneNumber)
    .sort((a, b) => {
      const aIsNotification = a.question.type === QuestionType.NotificationPhoneNumber ? 1 : 0;
      const bIsNotification = b.question.type === QuestionType.NotificationPhoneNumber ? 1 : 0;
      return aIsNotification - bIsNotification;
    });
  if (buyerQuestions.length === 0 && communicationPreferences.length === 0) {
    return null;
  }

  // Added preferences stay opaque, so only fade the section when all of it is placeholder.
  const isSectionGhostPreview =
    areQuestionsGhostPreview && (communicationPreferences.length === 0 || areCommunicationPreferencesGhostPreview);
  const questionSx = {
    marginTop: 1.5,
    ...(areQuestionsGhostPreview && !isSectionGhostPreview && { opacity: GHOST_PREVIEW_OPACITY }),
  };

  return (
    <SectionWrapper
      title={t("ticketing", isMembership ? "buyerQuestions" : "questions")}
      isGhostPreview={isSectionGhostPreview}
    >
      {buyerQuestions.map(({ question, index }) => {
        return type === FormType.Ticketing ? (
          <QuestionField
            key={question?.id}
            name={`customAnswersOfOrder.${index}`}
            question={question}
            id={`buyer-question-${index}`}
            sx={questionSx}
          />
        ) : (
          <QuestionField
            key={question?.id}
            name={`answers.${index}`}
            question={question}
            id={`buyer-question-${index}`}
            sx={questionSx}
          />
        );
      })}

      <CommunicationPreferencesFieldContainer />
    </SectionWrapper>
  );
};
